import PropTypes from 'prop-types'
import React, { Component } from 'react'
import '../sign-up/sign-up.css'
import errorImg from '../../../media/error-img.svg'

export default class Error404 extends Component {
  render() {
    const { t } = this.props

    return (
      <div className="sign-up-page xs-flex xs-justify-center xs-items-center xs-fill-gray-lighter clearfix">
        <div className="clearfix error-page">
          <div className="error-container xs-my6 col xs-col-12 sm-col-4 sm-offset-2 md-col-4 md-offset-3">
            <div className="h1 xs-pt2 bold">{t('OOPS')}</div>
            <div className="h1 xs-pt2 bold">{t('ERROR_404_OCCURED')}</div>
            <div className="xs-pt2 xs-text-gray-dark regular">{t('ERROR_404_INFO')}</div>
          </div>
          <div className="error-img-container col xs-col-12 sm-col-4 sm-offset-2 md-col-3 md-offset-2">
            <img className="error-img" alt="" src={errorImg} />
            <div className="h1 bold xs-p3">404</div>
          </div>
        </div>
      </div>
    )
  }
}

Error404.propTypes = {
  t: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/error-404/error-404.js